import { useCallback } from 'react';
import { GroupedPermission } from 'interfaces/group';

interface UseBuildGroupedPermissionResult {
  buildGroupedPermission: (data: any[], idPrefix: string) => GroupedPermission;
}

export function useBuildGroupedPermission(): UseBuildGroupedPermissionResult {
  const buildGroupedPermission = useCallback(
    (data: any[], idPrefix: string): GroupedPermission => {
      const grouped: GroupedPermission = {};

      data?.forEach((item) => {
        if (!grouped[item.domain]) {
          grouped[item.domain] = [];
        }

        grouped[item.domain].push({
          id: `${idPrefix}-${item.id}`,
          label: item.name,
          value: `${item.id}`,
          module_id: `${item.module?.id}` || '',
          description: item.description,
        });
      });

      return grouped;
    },
    []
  );

  return { buildGroupedPermission };
}
